// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"vendors-node_modules_glightbox_dist_js_glightbox_min_js":"ab919bf3c6b0ada1bdd9","src_js_components_ui_Glightbox_ts":"6f8a6fef5d5cc0efafd5","lazysizes":"b719b267ad82898ef968"}[chunkId] + ".js";
};